import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="py-24 flex flex-col items-center justify-center text-center">
      <h1 className="text-6xl font-bold text-brand-indigo mb-4">404</h1>
      <p className="text-xl text-gray-600 mb-8">This page got lost in the waiting room.</p>
      <Link 
        to="/" 
        className="px-6 py-3 bg-brand-mint text-brand-indigo font-medium rounded-full hover:bg-[#5cd4a6] transition-colors"
      >
        Return Home
      </Link>
    </div>
  );
};

export default NotFound;